import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaymentMethodValidationRequest } from '../models/request/payment-method-validation-request';
import { ResponseModel } from '../models/response-model';
import { PaymentMethodValidationResult } from '../models/response/payment-method-validation-result';

@Injectable({
  providedIn: 'root'
})
export class PaymentComplianceService {

  private url = `${environment.url}/paymentMethods/validate`;
  constructor(private readonly http: HttpClient) { }

  getPaymentMethodValidations(request: PaymentMethodValidationRequest) {
    return this.http.post<ResponseModel<PaymentMethodValidationResult>>(`${this.url}`, request);
  }
}
